'use strict';

import {
	UPDATE_ADDON_INGREDIENT,
	SET_ADDON_INGREDIENT,
	RESET_STATE
} from './addonIngredient.actions';

const defaultState = {
	data: {
		addonIngredient: {}
	}
};

function reducer(state = defaultState, action) {
	const { type, payload } = action;

	switch (type) {
	case SET_ADDON_INGREDIENT: {
		return {
			...state,
			data: {
				addonIngredient: payload
			}
		};
	}

	case UPDATE_ADDON_INGREDIENT: {
		return {
			...state,
			data: {
				addonIngredient: {
					...state.data.addonIngredient,
					...payload
				}
			}
		};
	}

	case RESET_STATE: {
		return {
			...state,
			data: {
				addonIngredient: defaultState.data.addonIngredient
			}
		};
	}

	default:
		return state;
	}
}

export default reducer;
